const fr = {
    'Total': 'Total',
    'Go to checkout': 'Continuer',
    'Coupon': 'Coupon',
    'Email': 'Email',
    'Proceed': 'Procéder à l\'achat',
    'Select a shipping method to continue': 'Sélectionner un mode de livraison pour continuer ',
    'Name': 'Nom',
    'Last name': 'Nom de famille',
    'Street': 'Rue',
    'Zip code': 'Code postal',
    'City': 'Ville',
    'Country': 'Pays',
    'State/Region': 'Province',
    'Change shipping address': 'Modifier l\'adresse de livraison',
    'Change billing address': 'Modifier l\'adresse de facturation',
    'Change payment method': 'Modifier la méthode de paiement',
    'Edit': 'Modifier',
    'Select shipping method': 'Sélectionner un mode de livraison',
    'Select payment method': 'Choisir une méthode de paiement',
    'Additional services': 'Services supplémentaires',
    'Apply': 'Appliquer',
    'Sign in': 'Connexion',
    'Password': 'Mot de passe',
    'I want to receive the <span>INVOICE</span>': 'Je veux recevoir la <span>facture</span>',
    'Invoice requested': 'Facture requise',
    'Fiscal code': 'NIF',
    'FC': 'NIF',
    'Quantity': 'Quantité',
    'Loading': 'Chargement',
    'Remove': 'Retour',
    'Back': 'Retour',
    '<strong>Add {tot}</strong> and we\'ll give you <strong>free</strong> shipping':
        '<strong>Ajouter {tot}</strong> pour une livraison <strong>gratuite</strong>',
    'Shipping informations': 'Information de livraison',
    'Shipping address': 'Adresse de livraison',
    'Address': 'Adresse',
    'Company Name': 'Nom de la société',
    'VAT Number': 'Numéro SIREN/SIRET',
    'PEC Address': 'Adresse de Courier Electronique Certifié',
    'SDI Code': 'SDI Code',
    'Are you sure you want to delete this item from cart': 'Es-tu sûr de vouloir supprimer cet article de tonpanier?',
    'Cart': 'Panier',
    'Shipping': 'Livraison',
    'Email and telephone number': 'E-mail et numéro de téléphone',
    'Billing address': 'Adresse de facturation',
    'Billing address is the same as the shipping address':
        'L\'adresse de facturation est la même que l\'adresse de livraison',
    'Selected address has invalid fields': 'L\'adresse sélectionnée contient des éléments non valides',
    'Continue as guest': 'Continuer en tant qu\'invité',
    'or': 'ou',
    'Recover password': 'Récupérer le mot de passe',
    'Account creation': 'Création du compte',
    'Continue': 'Continuer',
    'Please wait': 'Veuillez patienter',
    'Close': 'Fermer',
    'Order placed': 'Commande passée. Tu seras redirigé vers une page récapitulative',
    'Send remainder': 'Envoi d\'un email de récupération du mot de passe',
    'Password confirm': 'Confirmer le mot de passe',
    'Save address': 'Sauvegarder l\'adresse',
    'Street number': 'Numéro de maison',
    'Select a payment method': 'Sélectionner un mode de paiement',
    'Payment method': 'Mode de paiement',
    'Error during registration': 'Erreur lors de l\'enregistrement',
    'We have sent you an email to reset your password. Click on the link you will find inside.':
        'Nous t\'avons envoyé un e-mail pour réinitialiser ton mot de passe. Clique sur le lien que tu trouveras dedans.',
    'Service unavailable, retry later': 'Erreur temporaire, veuillez réessayer sous peu',
    'Error, try to logout and login back to proceed with checkout': 'Erreur, essayez de vous déconnecter et de vous reconnecter pour procéder au paiement',
    'Ordered products': 'Produits commandés',
    'No shipping methods available': 'Aucune méthode de livraison disponible',
    'We\'re unable to send the password reset email':
        'L\'e-mail de réinitialisation du mot de passe n\'a pas pu être envoyé. Veuillez vérifier l\'e-mail saisi ',
    'Do you have a promotional code?': 'Avez-vous un code promotionnel?',
    'Insert the code': 'Entrer le code',
    'Order summary': 'Résumé de la commande',
    'VAT': 'TVA',
    'Sign up': 'Créer un compte',
    'Already registered on': 'Tu es déjà inscrit(e)',
    'Don\'t have an account yet?': 'Vous n\'avez pas encore de compte?',
    'First time on': 'Première fois sur',
    'Create your personal account.': 'Crée ton compte personnel.',
    'Your Password': 'Votre mot de passe',
    'Your name': 'Ton nom',
    'Your last name': 'Ton nom de famille',
    'Choose a password': 'Choisir un mot de passe',
    'Your email': 'Votre adresse email',
    'Or sign in with your email address': 'Ou connecte-toi avec ton adresse e-mail',
    'Sign in with your email address': 'S\'identifier avec ton adresse e-mail',
    'Do you already have an account?': 'Vous avez déjà un compte?',
    'Create an account': 'Créer un compte',
    'Sign up with your email address': 'S\'inscrire avec ton adresse e-mail',
    'Continue shopping': 'Continuer le shopping',
    'Your cart is empty': 'Votre panier est vide',
    'product': 'produit',
    'products': 'produits',
    'Shipping included': 'Frais de livraison compris',
    'Choose a shipping address': 'Choisir une adresse de livraison',
    'There aren\'t shipping methods for this address, insert/select another one':
        'Il n\'y a pas de méthode d\'expédition pour cette adresse, veuillez en saisir/sélectionner une autre',
    'Attention, the cost of shipments has been updated': 'Attention, les frais de port ont été mis à jour',
    'Select an address': 'Sélectionner une adresse',
    'Save new address to proceed': 'Enregistrer la nouvelle adresse pour continuer',
    'Create new address to proceed': 'Créer une nouvelle adresse pour continuer',
    'Insert a valid email address to proceed': 'Veuillez saisir un email valide pour continuer',
    'Accept all agreements to proceed': 'Accepter les termes pour procéder',
    '<a href="{link}">Edit it</a> or insert/select another one':
        'Effectuer la <a href="{link}">modification</a> ou en saisir/sélectionner une autre',
    'Phone number': 'Téléphone portable',
    'Telephone number': 'Téléphone',
    'Contact details': 'Coordonnées',
    'Address details': 'Adresse de facturation',
    'Add new address': 'Ajouter une nouvelle adresse',
    'Enter Company Name': 'Saisir le nom de l\'entreprise',
    'Enter VAT Number': 'Insérer le numéro NIF',
    'Enter PEC address': 'Insérer l\'email de Courier Electronique Certifié',
    'Enter your SDI code': 'Enter your SDI code',
    'Please check your order.': 'Veuillez vérifier la commande',
    'By confirming your order, you accept our general terms and conditions as well as the information on security and data protection on www.passionebeauty.com.':
        'En confirmant votre commande, vous acceptez nos conditions générales ainsi que les informations relatives à la sécurité et à la protection des données sur le site www.passionebeauty.com',
    'Loading payment form, please wait': 'Chargement du formulaire de paiement, veuillez patienter',
    'Available for shipment': 'Disponible pour expédition',
    'I understand': 'Je comprends',
    'Forgot Your Password?': 'Mot de passe oublié?',
    'Step {step} of {steps}': 'Etape {step} de {steps}',
    'This field is mandatory': 'Ce champ est obligatoire',
    'Enter at least one of the two fields': 'Entrer au moins l\'un des deux champs',
    'Sales conditions': 'Conditions de vente',
    'Ops! The payment for your last order <strong>was unsuccessful and will be automatically deleted within 20 minutes</strong>. To try again click below and the procedure will start again.':
        'Oops! Le paiement de ta dernière commande <strong> a échoué et elle sera automatiquement annulée dans les 20 minutes qui suivent </strong>. Pour réessayer, clique sur le lien ci-dessous et la procédure recommencera. .<br/><br/> Attention : si tu as essayé d\'utiliser une carte-cadeau pendant ta commande, tu dois attendre l\'annulation de la commande (20 minutes) avant de pouvoir l\'utiliser à nouveau',
    'Do you prefer to return to visit the site and place your order later?':
        'Tu préfères revenir sur le site et passer ta commande plus tard?',
    'Reorder': 'Recommander',
    'Your last order has not been completed. If you want to add last order\'s items click on "Add" button':
        'Ta commande précédente n\'a pas été complétée. Si tu souhaites ajouter des produits de ta commande précédente, clique sur le bouton "Ajouter"',
    'Add': 'Ajouter',
    'Check the phone number: <strong>it must be a valid mobile phone</strong>.':
        'Vérifier le numéro de téléphone: <strong>ce doit etre un téléphone portable Français</strong>',
    'Change telephone number': 'Changer le numéro de téléphone',
    'Telephone must be a valid italian mobile phone': 'Le téléphone doit être un téléphone portable Français valide',
    'Do you have a gift card?': 'Avez-vous une carte-cadeau?',
    'Verify gift card': 'Verifier la carte cadeau',
    'Current balance': 'Solde actuel',
    'The gift card is invalid or empty. Please check the gift card and try again':
        'La carte cadeau est invalide ou vide. Vérifier la carte cadeau et réessayer',
    'Gift card applied': 'Carte Cadeau ajoutée',
    'Gift card was removed because the total amount is too low':
        'Carte cadeau supprimée car sa valeur dépasse le montant du panier. Ajouter d\'autres produits pour utiliser la carte-cadeau',
    'No payment information required': 'Aucune information de paiement n\'est requise',
    'Sign in with {social}': 'S\'identifier avec {social}',
    'Added to wishlist': 'Ajouté à la wishlist',
    'Do you want to add the product to your wish list before removing it?':
        'Veux-tu ajouter le produit à ta Wish List avant de le supprimer?',
    'Add to wishlist': 'Ajouter à la wishlist',
    'Please note! One or more products cannot be ordered. Please check the products highlighted in red in your shopping cart.':
        'Attention! Un ou plusieurs produits ne peuvent pas être commandés. Vérifier les produits surlignés en rouge dans le panier.',
    'Payment': 'Paiement',
    'Check': 'Vérifier',
    'VAT {taxPercent}% included': 'TVA de {taxPercent}% incluse',
    'Remise (Remboursement de la TVA)': 'Remboursement de la TVA',
    'Select': 'Sélectionner',
    'Change': 'Changement',
    'Pickup Point': 'Point relais sélectionné',
    'Change pickup point': 'Changer de point de retrait',
    'You have selected a different country, please choose your prefered shipping method':
        'Vous avez sélectionné un autre pays, veuillez choisir votre mode d\'expédition préféré',
    'Yes': 'Oui',
    'No': 'Non',
    'Choose whether to have the invoice or not to proceed':
        'Choisissez si vous souhaitez avoir la facture ou non pour continuer',
    'Please enter your email address below to receive a password reset link.':
        'Veuillez entrer votre adresse email ci-dessous pour recevoir le lien de réinitialisation du mot de passe.',
    'To see your cart, first log in to your Passione Beauty account.':
        'Pour consulter votre panier, connectez-vous d\'abord à votre compte Passione Beauty.',
    'If you need further assistance.': 'Si vous avez besoin d\'aide supplémentaire.',
    'Write to us': 'Écrivez-nous',
    'Registration completed successfully': 'Inscription terminée avec succès',
    'View and track order': 'Afficher et suivre la commande',
    'By completing this order you can earn {points}': 'En complétant cette commande, vous pouvez gagner {points}',
    'If you are registered with the Passione Club, with this order you will get {points}':
        'Si vous êtes inscrit au Passione Club, avec cette commande vous obtiendrez {points}',
    '{points} - completing order': '{points} - finalisation de la commande',
    '{points} - bonus for in-app purchase': '{points} - bonus pour l\'achat intégré',
    'Used up': 'Usé',
    'Sorry, we can\'t apply this service right now': 'Désolé, nous ne pouvons pas appliquer cet service pour le moment',
    'There is already an account with this email address. If you are sure that it is your email address, <a href="{url}">click here</a> to get your password and access your account.':
        'Il existe déjà un compte avec cette adresse email. Si vous êtes sûr que c\'est votre adresse email, <a href="{url}">cliquez ici</a> pour obtenir votre mot de passe et accédez à votre compte.',
    'If you\'d like to use a Coupon, please remove the Gift Card first':
        'Si vous souhaitez utiliser un coupon, veuillez d\'abord retirer la carte-cadeau',
    'Pay with a saved credit card': 'Payer avec une carte de crédit enregistrée',
    'Expiration': 'Expiration',
    'Pay with a new credit or debit card': 'Payer avec une nouvelle carte de crédit ou de débit',
    'Save credit card (one click payment)': 'Enregistrer la carte de crédit (paiement en un clic)',
    'Sign up with {social}': 'S\'enregistrer via {social}',
    'Registering with Facebook is very fast. There is no need to remember other passwords - no commitments for the brain. Don\'t worry, we won\'t share any information about you and we won\'t post anything on your behalf.':
        'L\'inscription via Facebook est très rapide. Il n\'est pas nécessaire de se souvenir d\'autres mots de passe - aucun sport pour le cerveau. Ne vous inquiètez pas, nous ne partagerons aucune information vous concernant et nous ne publierons rien en votre nom.',
    'Shipping Country': 'Pays de livraison',
    'Removing': 'Suppression',
    'Free shipping': 'Livraison Gratuite',
    'Save for future use': 'Enregistrer pour une utilisation future',
    'This order will be associated to your sales code:': 'Cette commande sera associée à votre code de vente :',
    'Delete card': 'Supprimer la carte',
    'Card deleted.': 'Carte supprimée.',
    'Use another card or another payment method to continue.':
        'Utilisez une autre carte ou un autre mode de paiement pour continuer.',
    'Try entering your card details again or use another payment method to continue.':
        'Essayez de saisir à nouveau les données de votre carte ou utilisez un autre mode de paiement pour continuer.',
    'There was an error deleting your card, please try again later':
        'Une erreur s\'est produite lors de la suppression de votre carte, veuillez réessayer plus tard',
    'Or register with your e-mail address': 'Ou s\'enregistrer avec mon adresse email',
    'ReCaptcha validation failed, please try again': 'Échec de la validation ReCaptcha, veuillez réessayer',
    'This site is protected by reCAPTCHA and the Google <a href="{privacyPolicyLink}">Privacy Policy</a> and <a href="{termsOfServiceLink}">Terms of Service</a> apply.':
        'Ce site est protégé par reCAPTCHA et les <a href="{privacyPolicyLink}">Politiques de confidentialité</a> et les <a href="{termsOfServiceLink}">Conditions d\'utilisation</a> de Google s\'appliquent.',
    'Forgot Password?': 'Mot de passe oublié?',
    'Conditions of sale for training courses': 'Conditions de vente des formations',
    'Previously it was: {omnibusPrice} -{omnibusPercentage}': 'Précédemment: {omnibusPrice} -{omnibusPercentage}',
    'How to read prices': 'Comment lire les prix',
    'Here is an example to understand what the prices you find mean':
        'Voici un exemple pour comprendre la signification des prix',
    'This is the original price of the item without discounts (list price)':
        'C\'est le prix initial de l\'article sans les remises (prix catalogue)',
    'This is the currently active discount on the item applied to the list price price expressed as a percentage':
        'Il s\'agit de la remise actuellement active sur l\'article, appliquée au prix catalogue et exprimée en pourcentage',
    'This is the current item price with discount applied and VAT included':
        'Il s\'agit du prix actuel de l\'article avec la remise appliquée et la TVA incluse',
    'This is the lowest price the item had in the last 30 days before it was discounted':
        'Il s\'agit du prix le plus bas que l\'article a eu dans les 30 jours précédant la remise',
    'Telephone prefix': 'Préfixe téléphonique',
    'Telephone without prefix': 'Téléphone sans préfixe',
    'Choose whether you have a VAT number or are a small business':
        "Choisissez si vous disposez d'un numéro de TVA ou si vous êtes une petite entreprise",
    'Card': 'Carte de crédit',
};

export default fr;
export const frValidation = {
    name: 'es',
    messages: {
        '_default': (e: any) => {
            return `La valeur du champ ${e} est invalide.`;
        },
        'after': (e: any, n: any) => {
            return `Le ${e} doit se situer après ${n[0]}.`;
        },
        'alpha': (e: any) => {
            return `Le champ ${e} ne peut contenir que des caractères alphabétiques.`;
        },
        'alpha_dash': (e: any) => {
            return `Le champ ${e} peut contenir des caractères alphanumériques ainsi que des tirets et des traits de soulignement.`;
        },
        'alpha_num': (e: any) => {
            return `Le champ ${e} ne peut contenir que des caractères alphanumériques.`;
        },
        'alpha_spaces': (e: any) => {
            return `Le champ ${e} ne peut contenir que des caractères alphanumériques et des espaces.`;
        },
        'before': (e: any, n: any) => {
            return `Le champ ${e} doit se situer avant ${n[0]}.`;
        },
        'between': (e: any, n: any) => {
            return `Le champ ${e} doit être compris entre ${n[0]} et ${n[1]}.`;
        },
        'confirmed': (e: any, n: any) => {
            return `Le champ ${e} ne correspond pas à ${n[0]}.`;
        },
        'credit_card': (e: any) => {
            return `Le champ ${e} n'est pas valide.`;
        },
        'date_between': (e: any, n: any) => {
            return `La ${e} doit être comprise entre ${n[0]} et ${n[1]}.`;
        },
        'date_format': (e: any, n: any) => {
            return `La ${e} doit être au format ${n[0]}.`;
        },
        'decimal': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions, no-void, no-param-reassign
            void 0 === n && (n = []);
            let r = n[0];
            // eslint-disable-next-line no-return-assign
            return (
                // eslint-disable-next-line no-void
                void 0 === r && (r = '*'),
                    `Le champ ${e} doit être numérique et peut contenir ${
                        r && r !== '*' ? ` ${r}` : ''
                    } des points décimaux.`
            );
        },
        'digits': (e: any, n: any) => {
            return `Le champ ${e} doit être numérique et contenir exactement ${n[0]} chiffres.`;
        },
        'dimensions': (e: any, n: any) => {
            return `Le champ ${e} doit être ${n[0]} x ${n[1]}.`;
        },
        'email': (e: any) => {
            return `Le champ ${e} doit être une adresse email valide.`;
        },
        'excluded': (e: any) => {
            return `Le champ ${e} doit avoir une valeur valide.`;
        },
        'ext': (e: any) => {
            return `Le champ ${e} doit être un fichier valide.`;
        },
        'image': (e: any) => {
            return `Le champ ${e} doit être une image.`;
        },
        'included': (e: any) => {
            return `Le champ ${e} doit avoir une valeur valide.`;
        },
        'ip': (e: any) => {
            return `Le champ ${e} doit être une adresse IP valide.`;
        },
        'length': (e: any, n: any) => {
            const r = n[0];
            const o = n[1];
            return o
                ? `La longueur du champ ${e} doit être comprise entre ${r} et ${o}.`
                : `La longueur du champ ${e} doit être ${r}.`;
        },
        'max': (e: any, n: any) => {
            return `Le champ ${e} ne peut être supérieure à ${n[0]} caractères.`;
        },
        'c': (e: any, n: any) => {
            return `Le champ ${e} doit être inférieur ou égal à ${n[0]}`;
        },
        'mimes': (e: any) => {
            return `Le champ ${e} doit avoir un type de fichier valide.`;
        },
        'min': (e: any, n: any) => {
            return `Le champ ${e} doit avoir au moins ${n[0]} caractères.`;
        },
        'min_value': (e: any, n: any) => {
            return `Le champ ${e} doit être supérieur ou égal à ${n[0]}`;
        },
        'numeric': (e: any) => {
            return `Le champ ${e} ne peut contenir que des caractères numériques.`;
        },
        'regex': (e: any) => {
            return `Attention le champ ${e} n'a pas un format valide.`;
        },
        'required': (e: any) => {
            return `Le champ ${e} est requis.`;
        },
        'size': (e: any, n: any) => {
            // eslint-disable-next-line @typescript-eslint/no-shadow
            return `Le champ ${e} doit être inférieur à ${((e) => {
                // eslint-disable-next-line @typescript-eslint/no-shadow
                const n = 1024;
                // eslint-disable-next-line no-cond-assign, no-param-reassign
                const r = (e = Number(e) * n) === 0 ? 0 : Math.floor(Math.log(e) / Math.log(n));
                const f = parseFloat((e / n ** r).toFixed(2));
                const v = 1 * f;
                return `${v.toFixed(2)} ${['Byte', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'][r]}`;
            })(n[0])}.`;
        },
        'url': (e: any) => {
            return `Le champ ${e} n'est pas un URL valide.`;
        },
        'validate-piva-cf': () => {
            return 'SIREN/SIRET/NIF non valide.';
        },
        'validate-regionid': () => {
            return 'Le champ province est requis.';
        },
        'validate-password-wf': () => {
            return 'La longueur minimale de ce champ doit être égale ou supérieure à {1} caractères. Les espaces de début et de fin ne sont pas pris en compte. Vérifiez qu\'il y a au moins 2 des 3 conditions suivantes : au moins une lettre majuscule, au moins un chiffre et au moins un caractère spécial.';
        },
        'validate-password-wf-length': () => {
            return 'La longueur minimale de ce champ doit être égale ou supérieure à {1} caractères. Les espaces de début et de fin ne sont pas pris en compte.';
        },
        'validate-password-wf-character': () => {
            return 'Vérifiez qu\'il y a au moins 2 des 3 conditions suivantes : au moins une lettre majuscule, au moins un chiffre, au moins un caractère spécial.';
        },
        'validate-length': (e: any) => {
            return `Attention le champ ${e} doit avoir une longueur de {1} caractères.`;
        },
        'validate-fiscal-code': () => {
            return 'Votre NIF doit etre composé de 13 chiffres.';
        },
        'validate-telephone-without-prefix': () => {
            return 'Merci de saisir un numéro de téléphone valide, ne doit pas contenir le préfixe (par exemple +33).';
        },
        'validate-foreign-country-telephone-without-prefix': () => {
            return 'Merci de saisir un numéro de téléphone valide, ne doit pas contenir le préfixe (par exemple +33).';
        }
    },
    attributes: {}
};
